import { Location } from "@/__generated__/graphql";
import DescriptionSectionView from "@/components/sections/DescriptionSectionView";
import { Box, Button } from "@mui/joy";
import { FormattedMessage } from "react-intl";

export default function SchoolRulesView({
  location,
  contractUrl,
}: {
  location: Location;
  contractUrl?: string | null;
}) {
  return (
    <Box>
      <DescriptionSectionView content={location.schoolRules} />
      <Button
        fullWidth
        component="a"
        target="_blank"
        rel="noopener noreferrer"
        href={contractUrl ?? undefined}
        disabled={!contractUrl}
      >
        <FormattedMessage defaultMessage="Ознакомиться с договором" />
      </Button>
    </Box>
  );
}
